import { useState, useEffect } from 'react'
// services
import LessonsServices from 'services/lesson'
// state
import { useSelector } from 'react-redux'

export default function useCurrentLesson() {
	// redux
	const {
		session: { userId }
	} = useSelector(state => state)

	// state
	const [lessonState, setLessonState] = useState(false)

	// calls
	const getCurrentLesson = () => {
		LessonsServices.getCurrentLesson({ userId })
			.then(res => {
				if (res.status === 200) {
					setLessonState(res.data)
				}
			})
	}

	useEffect(() => {
		getCurrentLesson()
	}, [])

	return { lessonState }
}
